import $ from 'jquery';
import '../../utility/csrf';
import AppStore from '../../stores/AppStore';

export function guestPayment(params = {}) {

	$('.spinneroverlay').show()

	params.donationAmount = AppStore.getDonationAmount();
	params.currencyCode = AppStore.getDonationCode();
	params.currencySymbol = AppStore.getDonationSymbol();
	params.shareAddress = AppStore.getShareAddress();

	return new Promise((resolve, reject) => {
		$.post('/donate/guest/onboarding', params, (result) => {
			return resolve(result);
		}).fail((err) => {
			return reject(err)
		}).always(() => {
			$('.spinneroverlay').hide();
		})
	})
};



// WEBPACK FOOTER //
// ./pages/guest/helper.js